import React, { useState, useEffect } from 'react';
import { loginTemplates, getTemplatesByCategory } from '@/lib/loginTemplates';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';
import CategorySection from './CategorySection';
import LoginCard from './LoginCard';

const LoginShowcase: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [categories, setCategories] = useState<Map<string, any>>(new Map());
  
  useEffect(() => {
    setCategories(getTemplatesByCategory());
  }, []);
  
  const filteredTemplates = loginTemplates.filter(template => 
    template.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  const getCategoryTitle = (category: string): string => {
    switch(category) {
      case 'social': return 'Social Media';
      case 'business': return 'Business & Work';
      case 'payment': return 'Payment Apps';
      case 'entertainment': return 'Entertainment';
      case 'gaming': return 'Gaming';
      default: return category;
    }
  };
  
  return (
    <div className="w-full max-w-7xl mx-auto px-6 py-12">
      <div className="mb-12 text-center space-y-3 max-w-3xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground">
          NEXUS Phish
        </h1>
        <p className="text-xl text-muted-foreground">
          A phishing attack simulation tool built by NEXUSCIPHERGUARD INDIA
        </p>
      </div>
      
      <div className="mb-8 max-w-md mx-auto">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
          <Input
            type="text"
            placeholder="Search platforms..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10"
          />
        </div>
      </div>
      
      {searchTerm ? (
        <div>
          <h2 className="text-2xl font-bold mb-6">Search Results</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredTemplates.map((template, index) => (
              <div key={template.id} className="animate-fade-in" style={{ animationDelay: `${index * 50}ms` }}>
                <LoginCard template={template} index={index} />
              </div>
            ))}
            
            {filteredTemplates.length === 0 && (
              <div className="col-span-full text-center py-12">
                <p className="text-muted-foreground">No results found for "{searchTerm}"</p>
              </div>
            )}
          </div>
        </div>
      ) : (
        Array.from(categories.entries()).map(([category, templates]) => (
          <CategorySection 
            key={category} 
            title={getCategoryTitle(category)} 
            templates={templates} 
          />
        ))
      )}
    </div>
  );
};

export default LoginShowcase;